module.exports = __webpack_public_path__ + "img/ver7.edfcee62.jpg";